import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

const VerifyEmailPage = lazy(() =>
  import('@/features/auth/verify-email/VerifyEmailPage').then((m) => ({ default: m.VerifyEmailPage })),
);

const verifyEmailSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/verify-email')({
  validateSearch: verifyEmailSearchSchema,
  component: () => (
    <Suspense>
      <VerifyEmailPage />
    </Suspense>
  ),
});
